<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content" [ngClass]="{ yellow: pending }">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div class="ui basic segment" *ngIf="success || error">
      <div class="ui success message" *ngIf="success">
        <i (click)="close()" class="close icon"></i>
        {{ success }}
      </div>
      <div class="ui warning message" *ngIf="error">
        <i (click)="close()" class="close icon"></i>
        {{ error | json }}
      </div>
    </div>
    <div class="ui form" [formGroup]="workGroupFormGroup">
      <div class="field" [ngClass]="displayFieldCss('name')">
        <label class="required">Name</label>
        <input type="text" formControlName="name" placeholder="Name" />
        <app-field-error-display
          [displayError]="isFieldValid('name')"
          errorMsg="Please enter name"
        >
        </app-field-error-display>
      </div>
      <div class="field" [ngClass]="displayFieldCss('description')">
        <label class="required">Description</label>
        <input
          type="text"
          formControlName="description"
          placeholder="Description"
        />
        <app-field-error-display
          [displayError]="isFieldValid('description')"
          errorMsg="Please enter description"
        >
        </app-field-error-display>
      </div>
      <div class="field">
        <label class="required">Select Users</label>
        <div class="ui mini icon input">
          <input
            type="text"
            placeholder="Search Users"
            [formControl]="search"
          />
          <i class="search icon"></i>
        </div>
        <div
          class="option"
          fxLayout="row"
          *ngFor="let user of allUsers"
          style="background-color: #f0f1f8; border-radius: 10px"
          fxLayoutAlign="space-between center"
          marginX="0"
          appPadding
          paddingL="20px"
          paddingY="10px"
          paddingR="10px"
          appMargin
          marginY="10px"
        >
          <div
            fxFlex="grow"
            fxLayout="row"
            fxLayoutGap="15px"
            fxLayoutAlign="start center"
          >
            <div>
              <img
                style="width: 50px"
                src="../../../../../assets/avatar/1.jpg"
                alt="image"
                class="ui tiny circular image avatar"
              />
            </div>
            <div fxLayout="column" fxLayoutGap="10px">
              <div class="ui header fw-bold" style="font-size: 15px">
                {{ user.name || "-" }}
              </div>
              <div
                *ngIf="user.active"
                style="width: 50px"
                class="ui circular mini green label"
              >
                ACTIVE
              </div>
              <div
                *ngIf="!user.active"
                style="width: 55px"
                class="ui circular mini red label"
              >
                INACTIVE
              </div>
            </div>
          </div>
          <div fxFlex="auto">
            <input
              class="checkbox"
              [checked]="isChecked(user.appUserId)"
              name="read"
              type="checkbox"
              (change)="checkChange(user.appUserId, $event)"
            />
          </div>
        </div>
        <div class="ui vertical basic segment">
          <div class="ui two column grid">
            <div class="column middle aligned">
              <div class="ui icon small button">
                <i class="database icon"></i>
              </div>
              <a class="ui basic label">{{ totalItems }} Record(s)</a>
            </div>
            <div
              class="column right aligned pagination menu"
              style="margin-left: auto"
            >
              <sui-pagination
                class="small"
                [collectionSize]="totalItems"
                [pageSize]="rows"
                [maxSize]="maxSize"
                [hasEllipses]="false"
                [page]="currentPage"
                (pageChange)="nextPage($event)"
              >
              </sui-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="actions">
    <button class="ui button back" (click)="modal.deny(undefined)">
      Cancel
    </button>
    <button
      class="ui primary button"
      [ngClass]="{ yellow: pending }"
      [disabled]="
        pending || !workGroupFormGroup.valid || selectedUsers.length < 1
      "
      autofocus
      (click)="save()"
    >
      Save
    </button>
  </div>
</div>
